module.exports = __webpack_public_path__ + "3cbc518ae17858a8c464c2be34b7bdbd.png";